import { useRecordHasAttachments } from "@/components/common/DocumentsPanel";

/**
 * Presence check for a policy's first-class document attachments (#6505 / ADR-086).
 *
 * Thin policy-typed wrapper over the shared {@link useRecordHasAttachments}
 * (#6506 generalized this hook so claimant/client/vendor share one
 * implementation). Reads the attachment relation, NOT `policies.source_documents`
 * (provenance). See the shared hook for the fail-open semantics.
 */
export const usePolicyHasAttachments = (policyId?: string) => useRecordHasAttachments("policy", policyId);
